import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Card, Grid, Header, Dimmer, Loader} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import _ from 'lodash';
import REST from 'go/requests/rest';
import toggles from 'go/actions/api/toggles';

const taskPhases = {
  'preAwardPassthrough-subAppECReview': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-preScoreReview': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-insuranceReview': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-mitigationPlanReview': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-preliminaryCostEffectivenessReview':
    'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-technicalReview': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-ehpScreening': 'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-subAppECDeterminationReview':
    'Pre-award Eligibility and Completeness',
  'preAwardPassthrough-compMeritReviewResults': 'Pre-award Competitive Merit Review',
  'awardPackageReview-ptAwardPackageReview': 'Pre-award Award Package Review',
  'awardPackageReview-ptAwardPackageApproval': 'Pre-award Award Package Review',
  'preAwardPassthrough-programmaticReviewTriage': 'Pre-award Programmatic Review',
  'preAwardPassthrough-psAwardRecommendation': 'Pre-award Programmatic Review',
  'preAwardPassthrough-grantsManagementAwardReview': 'Pre-award Grants Management Review',
  'preAwardPassthrough-grantsManagementAwardApproval':
    'Pre-award Grants Management Review',
  'preAwardPassthrough-confirmCongressionalNotification':
    'Pre-award Congressional Notification',
  'preAwardPassthrough-asaSignAwardPackage': 'Pre-award Award Signature',
  'preAwardPassthrough-declinedAwardReview': 'Award Acceptance',
  'preAwardPassthrough-aoDeclinedAwardReview': 'Pre-Award Deobligation Confirmation',
  'amendmentPassthrough-psAmendmentRecommendation': 'Post-award',
  'amendmentPassthrough-grantsManagementAmendmentReview': 'Post-award',
  'amendmentPassthrough-grantsManagementAmendmentApproval': 'Post-award',
  'amendmentPassthrough-congressionalNotificationForAmendments': 'Post-award',
  'amendmentPassthrough-asaSignAmendmentPackageSingle': 'Post-award',
  'subCloseoutReport-subGrantCloseoutReview': 'Closeout',
  'closeoutReport-ifmisGrantClosureConfirmation':'Closeout',
  'closeoutReport-closeoutDeobligationApproval':'Closeout',
  'closeoutReport-closeoutDeobligationApprovalRF':'Closeout',
  'closeoutReport-financialCloseoutReview':'Closeout',
  'closeoutReport-programmaticCloseoutReview':'Closeout',
  'closeoutReport-returnOfFundConfirmation':'Closeout',
};
export class UnassignedSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tasks: [],
      phase: {
        'Pre-Award': 'Pre-Award',
        'Pre-AwardHMA': 'Pre-Award HMA',
        'Pre-Award Direct': 'Pre-Award',
        'Pre-Award Pass Through': 'Pre-Award',
        subAppIneligibilityReview: 'Pre-Award',
        'Request For Assistance': 'Pre-Award',
        Award: 'Award',
        AwardDirect: 'Award',
        Obligation: 'Continuous',
        Payment: 'Continuous',
        Amendment: 'Post-Award',
        'Payment request': 'Post-Award',
      },
      loading: true,
    };
  }

  componentDidMount() {
    REST.workflow
      .getTaskSummary(this.props.jwt)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        if (resJson) {
          this.setState({tasks: resJson, loading: false});
          return resJson;
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const {loading} = this.state;
    const toggles = this.props.toggles;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');
    let tasks = this.state.tasks;
    if (dunsToUEIToggle) {
      tasks = tasks.filter(
        (task) =>
          task.taskDefKey != 'gmsLinkVendorToApplication' &&
          task.taskDefKey != 'hmaGmsLinkVendorToApplication'
      );
    }
    const tasksGrouped = _.chain(tasks)
      .filter((task) => task.needsGrouping != 'false')
      .groupBy('needsGrouping')
      .map((value, key) => ({
        groupName: key,
        groupUnassignedCount: _.sumBy(value, 'unassignedCount'),
        groupAgedCount: _.sumBy(value, 'agedCount'),
        groupProcessDefKey: _.map(value, 'processDefKey'),
        groupTaskDefKey: _.reduce(_.map(value, 'taskDefKey')),
        groupAllowBulkCompletion: _.reduce(_.map(value, 'allowBulkCompletion')),
        groupTaskName: _.reduce(_.map(value, 'taskName')),
        groupProcessName: _.reduce(_.map(value, 'processName')),
        tasks: value,
      }))
      .value();

    const tasksUngrouped = _.chain(tasks)
      .filter((task) => task.needsGrouping == 'false')
      .value();

    const tasksFinal = tasksGrouped.concat(tasksUngrouped);

    const columns = _.chain(tasksFinal)
      .filter((task) => task.processDefKey != 'panelReview')
      .map((task, index) =>
        task.groupName ? (
          <Grid.Column key={index}>
            <Card fluid>
              <Card.Content>
                <Header as="h3">{task.groupTaskName}</Header>
                <Card.Meta>Unassigned tasks: {task.groupUnassignedCount}</Card.Meta>
              </Card.Content>
              <Card.Content className="noPadding">
                <Grid celled="internally" columns={2}>
                  <Grid.Column textAlign="left">
                    <Header as="h6">Phase</Header>
                    {this.state.phase[task.groupProcessName]}
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    <Header as="h6">Tasks past a week</Header>
                    {task.groupAgedCount}
                  </Grid.Column>
                </Grid>
              </Card.Content>
              <Card.Content>
                <Card.Description>
                  <Link
                    to={
                      (task.groupAllowBulkCompletion === 'true' ||
                      Boolean(task.groupAllowBulkCompletion)
                        ? 'bulk/list'
                        : 'list') +
                      '?processDefinitionKeyIn=' +
                      task.groupProcessDefKey +
                      '&taskDefinitionKey=' +
                      task.groupTaskDefKey +
                      '&taskName=' +
                      task.groupTaskName
                    }
                    title={`View ${task.groupTaskName}`}
                  >
                    View >
                  </Link>
                </Card.Description>
              </Card.Content>
            </Card>
          </Grid.Column>
        ) : (
          <Grid.Column key={index}>
            <Card fluid>
              <Card.Content>
                <Header as="h3">{task.taskName}</Header>
                <Card.Meta>Unassigned tasks: {task.unassignedCount}</Card.Meta>
              </Card.Content>
              <Card.Content className="noPadding">
                <Grid celled="internally" columns={2}>
                  <Grid.Column textAlign="left">
                    <Header as="h6">Phase</Header>
                    {taskPhases[task.processDefKey + '-' + task.taskDefKey]
                      ? taskPhases[task.processDefKey + '-' + task.taskDefKey]
                      : this.state.phase[task.processName]}
                  </Grid.Column>
                  <Grid.Column textAlign="right">
                    <Header as="h6">Tasks past a week</Header>
                    {task.agedCount}
                  </Grid.Column>
                </Grid>
              </Card.Content>
              <Card.Content>
                <Card.Description>
                  <Link
                    to={
                      (task.allowBulkCompletion === 'true' ||
                      Boolean(task.allowBulkCompletion)
                        ? 'bulk/list'
                        : 'list') +
                      '?processDefinitionKey=' +
                      task.processDefKey +
                      '&taskDefinitionKey=' +
                      task.taskDefKey +
                      '&taskName=' +
                      task.taskName
                    }
                    title={`View ${task.taskName}`}
                  >
                    View >
                  </Link>
                </Card.Description>
              </Card.Content>
            </Card>
          </Grid.Column>
        )
      )
      .value();

    const taskList = [];
    const colsPerRow = 4;

    if (loading) {
      return <Loader active>Loading...</Loader>;
    } else {
      if (columns.length === 0) {
        return (
          <Grid.Row>
            <Grid.Column width={16}>
              <Alert header="No tasks available" type="info">
                There are currently no tasks available for you to work on.
              </Alert>
            </Grid.Column>
          </Grid.Row>
        );
      }

      // distribute Semantic Columns into Semantic Rows
      while (columns.length > 0) {
        taskList.push(
          <Grid.Row columns={colsPerRow} key={columns.length}>
            {columns.splice(0, colsPerRow)}
          </Grid.Row>
        );
      }

      return taskList;
    }
  }
}
export const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    jwt: state.auth.token,
    messages: state.messages.messages,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    clearAllMsg: () => {
      dispatch({type: CLEAR_ALL_MSG});
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UnassignedSummary);
